<template>
  <v-dialog v-model="isActiveModal" width="350">
    <v-card>
      <v-toolbar dense color="#27e96a" :dark="true">
        <v-toolbar-title>Seleccione</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeModal()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-container fluid class="d-flex flex-column PaddingDivFilter">
        <v-row justify="center padding-min">
          <v-col class="m-1">
            <div>Numero de instancias a agregar:</div>
            <v-text-field
              class="mt-5"
              type="number"
              label="Instancias"
              v-model="numberInstancias"
              single-line
              solo
              color="#27e96a"
              hint="Ingrese Número de Instancias"
            ></v-text-field>
          </v-col>
        </v-row>
        <div class="d-flex justify-space-around">
          <v-btn
            tile
            :disabled="isValidDownloads"
            class="button-tertiary pl-6 pr-6"
            outlined
            @click="save()"
          >
            Aceptar
            <template v-slot:loader>
              <span class="custom-loader">
                <v-icon light>mdi-autorenew</v-icon>
              </span>
            </template>
          </v-btn>
          <v-btn
            tile
            outlined
            class="button-primary pl-6 pr-6"
            @click="closeModal()"
          >
            Cancel
          </v-btn>
        </div>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    isActiveModal: {
      type: Boolean,
      required: true,
      default: false,
    },
    instances: [],
  },
  data: () => ({
    numberInstancias: "",
  }),
  methods: {
    closeModal() {
      this.resetVariables();
      this.$emit("close");
    },
    save() {
      if (this.numberInstancias != this.instances.length) {
        this.$store.dispatch("rtpEngine/addInstances", this.numberInstancias);
        this.closeModal();
        return;
      }
      this.closeModal();
      this.resetVariables();
    },
    resetVariables() {
      (this.numberInstancias = ""), (this.isActiveModal = false);
    },
  },
  watch: {
    instances(value) {
      if (typeof value != "undefined") {
        this.numberInstancias = value.length;
      }
    },
  },
};
</script>

<style>
.PaddingDivFilter {
  padding-bottom: 2rem !important;
}
</style>
